//客户附加费维护
import TableList from "@components/templates/tablelist";
// import { HttpAddonRuleList, HttpCopyAddonRule, HttpDelAddonRuleList, HttpDelAddonRule } from "@/service/fedex";
import { HttpAddonRuleList, HttpCopyAddonRule, HttpDelAddonRule } from "@/service/fedex";
import { HttpOtherLogiServiceList,HttpGetCarrierGroupByOrg,HttpGetCarrierGroup, HttpDownloadMaterialTemplate } from "@/service/carrieraccount";
import comExtraCopy from './comExtraCopy'
import { mapState, mapGetters } from 'vuex';

import mixin from '../mixin'
export default {
    mixins: [TableList, mixin],
    components:{
        comExtraCopy,
    },
    data() {
        return {
            isMixin: true,
            Tools: { show: true },
            Tabs: { show: true },
            exportdata: {},
            Searchs: {
                show: true,
                labelWidth: 90
            },
            Plugins: { show: true }
        };
    },
    created() {
        // 添加权限
    },
    methods: {
        ajaxRequest: HttpAddonRuleList,
        interceptRequest(data) {
            data.search.LE_startTime = data.search.effectTime;
            data.search.GE_endTime = data.search.effectTime;
            delete data.search.effectTime;
            this.exportdata = data;
            return data
        },
        handleOperates(params = "", type, batch) {
            if (batch === true) {
                params = (params || this.checkedData.join(",")) + "";
                if (!params.length)
                    return this.$VMessage.warning(this.$t('global.common.choose_one', { defaultValue: '请选择至少一条数据' }));
            }
            switch (type) {
                case "add":
                    this.$router.push({
                        name: "carrierUpdateExtra",
                        params: { type: "add" },
                    });
                    break;
                case "edit":
                    this.$router.push({
                        name: "carrierUpdateExtra",
                        params: { type: "edit" },
                        query: { id: params }
                    });
                    break;
                case "query":
                    {
                        let url = this.$router.resolve({
                            name: "carrierUpdateExtra",
                            params: { type: "query" },
                            query: { id: params }
                        });
                        window.open(url.href, "_blank");
                    }
                    break;
                case "del":
                    this.operate = {
                        show: true,
                        alert: "error",
                        params: { id: params },
                        title: this.$t('global.common.delete', { defaultValue: '删除' }),
                        desc:this.$t('fbb.localemanage.confirm_delete', { defaultValue: '删除后不可恢复，是否确认删除？' }),
                        ajaxRequest: HttpDelAddonRule
                    };
                    break;
                case "copy":
                    this.operate = {
                        title: this.$t('fbb.carrier.extra_copy', { defaultValue: '规则复制' }),
                        show:true,
                        width:450,
                        alert: "info",
                        component: "comExtraCopy",
                        itemjson:params,
                        querytype:'query',
                        showFooter:false,
                        showDesc: false,
                        formdata: [{
                            label: this.$t('fbb.carrier.extra_source', { defaultValue: '来源组织' }),
                            tag: 'vSelect',
                            key: "sourceOrgId",
                            span: 24,
                            props: {
                                filterable: true
                            },
                            options: this.getOrgOpt
                        }, {
                            label: this.$t('fbb.carrier.extra_source_service', { defaultValue: '来源承运商服务' }),
                            tag: 'vSelect',
                            key: "sourceServiceId",
                            span: 24,
                            props: {
                                filterable: true
                            },
                            options: this.getCarrierServiceOpt
                        }, {
                            label: this.$t('fbb.carrier.extra_target_org', { defaultValue: '目标组织' }),
                            tag: 'vSelect',
                            key: "targetOrgIdList",
                            span: 24,
                            props: {
                                filterable: true,
                                multiple:true,
                            },
                            options: this.getOrgOpt
                        }, {
                            query: true,
                            formItem: {
                                labelWidth: 60
                            },
                            span: 24,
                            valueText: '<div class="color-error">'+this.$t('fbb.carrier.extra_sure_copy', { defaultValue: '确认复制后，目标组织对应承运商服务原附加规则会被清除，请谨慎操作!' })+'</div>'
                        }]
                    };
                    break;
                // case "batchDel":
                //     this.operate = {
                //         show: true,
                //         alert: "error",
                //         params: {
                //             ids: params
                //         },
                //         title: this.$t('global.common.delete', { defaultValue: '删除' }),
                //         desc:this.$t('fbb.localemanage.confirm_delete', { defaultValue: '删除后不可恢复，是否确认删除？' }),
                //         ajaxRequest: HttpDelAddonRuleList
                //     };
                //     break;
                case 'import':
                    this.operate = {
                        show: true,
                        title: "导入数据",
                        showDesc: false,
                        component: "compUpload",
                        name: "multipartFile",
                        width:450,
                        showFooter: false,
                        action: process.env.VUE_APP_APIURL_FBB + "/api/v2/carrierAddonRule/importData",
                        download: () => {
							this.handleWebfs(process.env.VUE_APP_APIURL_FBB + "/api/v2/carrierAddonRule/importTemplate", {}, {
                                executor:'request',
                                download:true,
                                method: 'post',
                            })
						},
                        callback:()=>{
                            this.$emit('on-update');
                            this.operate = {};
                        }
                    };
                    break;
                case 'export':
                    this.handleWebfs(process.env.VUE_APP_APIURL_FBB + '/api/v2/carrierAddonRule/export', this.exportdata, {
                        executor: 'request',
                        download: true,
                        method: 'get',
                    })
                    break;
            }
        },
        getOperateNodeMap(row) {
            const { id } = row;
            return [
                {
                    label: this.$t('global.common.query', { defaultValue: '查看' }),
                    params: id,
                    show: true,
                    operate: "query"
                },
                {
                    label: this.$t('global.common.operation_edit', { defaultValue: '编辑' }),
                    params: id,
                    show: true,
                    operate: "edit"
                },
                {
                    label: this.$t('global.common.delete', { defaultValue: '删除' }),
                    params: id,
                    show: true,
                    operate: "del"
                }
            ];
        }
    },
    computed: {
        ...mapGetters('dictionary', ['getNextOrgList','getLogiticdProCodeList','getNewAllProductList','getCountryList', 'getCustomServiceAllList', 'getCustomServiceProductAllList']),
        ToolsData() {
            return [
                {
                    name: this.$t('erp.product.new_add', { defaultValue: '添加' }),
                    operate: "add",
                    theme: "primary"
                },
                {
                    name: this.$t('fbb.carrier.extra_copy', { defaultValue: '规则复制' }),
                    operate: "copy",
                    theme: "info"
                },
                // {
                //     label: this.$t('fbb.accountmanage.muti_loss_effect', { defaultValue: "批量失效" }),
                //     operate: "batchDel",
                //     theme: "primary",
                //     batch: true,
                //     more: true,
                // },
                {
                    name: "导入",
                    operate: "import",
                },
                {
                    // name: this.$t('fbb.inbound_import_data', { defaultValue: '导入数据' }),
                    // operate: "import",
                    name: "导出",
                    operate: "export",
                    // more: true,
                },
            ];
        },
        SearchsData() {
            return [
                {
                    label: this.$t('bi.work.task_org_id', { defaultValue: '组织' }),
                    tag: "vSelect",
                    key: "EQ_orgId",
                    show: true,
                    options: this.getNextOrgList,
                    props: {
                        filterable: true
                    }
                },
                {
                    label: this.$t('global.common.line', { defaultValue: "项目" }),
                    tag: "vSelect",
                    key: "EQ_lineId",
                    show: true,
                    options: this.getNewAllProductList,
                    props: {
                        filterable: true
                    }
                },
                {
                    // label: this.$t('fbb.alloment.carrier_code', { defaultValue: '物流商' }),
                    label: "物流产品",
                    tag: "vSelect",
                    key: "EQ_groupId",
                    show: true,
                    props: {
                        filterable: true
                    },
                    // options: this.hostGroupList
                    options: this.getCustomServiceAllList,
                },
                {
                    label: this.$t('fbb.alloment.carrier_server', { defaultValue: '物流商服务' }),
                    tag: "vSelect",
                    key: "EQ_logisticsServiceCode",
                    props: {
                        filterable: true
                    },
                    // options: this.getLogiticdProCodeList
                    options: this.getCustomServiceProductAllList.map(item=>{
                        return {value: item.attach.code, label: item.label}
                    })
                },
                {
                    label:this.$t('erp.channelbase.country',{defaultValue:'国家'}),
                    tag:'Select',
                    key:'EQ_regionCode',
                    options:this.getCountryList.map(item=>{
                        return {
                            value:item.value,
                            label:item.label
                        }
                    }),
                },
                {
                    label:this.$t('fbb.account.takeeffect',{defaultValue:'生效日期'}),
                    key:'effectTime',
                    tag: "vDatepicker",
                    props: {
                        format: "yyyy-mm-dd",
                        confirm: false,
                    },
                },
                {
                    label: '规则名称',
                    tag: 'vInput',
                    key: 'CN_ruleName',
                },
            ];
        },
        columns() {
            return [
                // {
                //     type: 'selection',
                //     width: 40,
                //     align: 'center',
                //     formName: 'id'
                // },
                {
                    title: this.$t('global.common.actions', { defaultValue: '操作' }),
                    width: 90,
                    render: this.getOperateNodes
                },
                {
                    title: this.$t('bi.work.task_org_id', { defaultValue: '组织' }),
                    key: "orgId",
                    sortable: true,
                    render: (h, { row }) => this.findRenderLabel(this.getOrgOpt, row.orgId) || '--'
                },
                {
                    title: this.$t('erp.channelbase.country', { defaultValue: '国家' }),
                    key: "regionCode",
                    sortable: true,
                    render: (h, { row }) => {
                        const regionCountry=this.getCountryList.filter(item=>item.value===row.regionCode)[0]
                        return regionCountry?regionCountry.label:'--'
                    }
                },
                {
                    title: this.$t('global.common.line', { defaultValue: "项目" }),
                    key: "lineName",
                    sortable: true,
                    // render: (h, { row }) => this.findRenderLabel(this.getNewAllProductList, row.lineId)|| '--'
                    render: (h, { row }) => {
                        return <div>{row.lineName || '--'}</div>
                    }
                },
                {
                    // title: this.$t('fbb.alloment.carrier_code', { defaultValue: '物流商' }),
                    title: "物流产品",
                    key: 'groupName',
                },
                {
                    title: this.$t('fbb.alloment.carrier_server', { defaultValue: '物流商服务' }),
                    sortable: true,
                    key: "logisticsServiceCode",
                },
                {
                    title: this.$t('fbb.carrier.extra_rule_group', { defaultValue: '规则分组' }),
                    sortable: true,
                    key: "ruleGroup",
                    // template: this.$t('fbb.carrier.extra_group', { defaultValue: '分组' })+"{ruleGroup}",
                },
                {
                    title: this.$t('fbb.carrier.extra_rule_name', { defaultValue: '规则名称' }),
                    sortable: true,
                    key: "ruleName"
                },
                {
                    title: this.$t('fbb.carrier.extra_rule_cost', { defaultValue: '计费值' })+'（USD）',
                    key: "ruleCostFormula"
                },
                {
                    title: this.$t('fbb.carrier.discount_rate', { defaultValue: '折扣率' }),
                    key: "discount"
                },
                {
                    title: this.$t('fbb.carrier.extra_rule_remark', { defaultValue: '规则描述' }),
                    key: "remark"
                },
                {
                    title: '适用分区范围起',
                    key: "zoneStart"
                },
                {
                    title: '适用分区范围止',
                    key: "zoneEnd"
                },
                {
                    title:this.$t('fbb.account.takeeffectstart',{defaultValue:'生效开始日期'}),
                    key:'startTime',
                },
                {
                    title:this.$t('fbb.account.takeeffectend',{defaultValue:'生效结束日期'}),
                    key:'endTime',
                },
            ];
        }
    }
};
